var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    className: "fill-current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.668 4.827l-1.095-.04-.238 6.488 1.096.04.237-6.488zM7.548 4.807H6.452v6.488h1.096V4.807zM5.665 11.275l-.237-6.489-1.096.04.237 6.489 1.096-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.475 2.102v1.096h1.143L2.525 13.5c.024.283.261.5.546.5h7.84a.548.548 0 00.546-.5l.907-10.302h1.16V2.102H.476zm9.934 10.801H3.573l-.854-9.705h8.544l-.854 9.705z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.791 0H5.209a.915.915 0 00-.914.914V2.65h1.097V1.097h3.216V2.65h1.097V.914A.915.915 0 008.79 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.416f8d3c3dcca249c0bf4e0c455fb010.svg";
export { ForwardRef as ReactComponent };